import React, { useState, useEffect } from 'react'
import MBAformN from './components/formN';
import MDformO from './components/formO';
import { ToastContainer } from "react-toastify";
// import SponsorAgreementP1 from './components/Page1';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from "react-toastify";
import { useLocation } from 'react-router-dom';
import { getAggreementFormReview } from "../../../auth/services/apiCalling"
import { sponsorRegistration } from '../../../../core/data/json/contractFarming';
import { useDispatch, useSelector } from "react-redux";
import { setMainLoader } from '../../../../core/data/redux/authSlice'; ////explicitly import setMainLoader

const MarketingBoardAgreement = () => {
  const userDetail = useSelector((state: any) => state.auth.userDetails);
  const roleIdentifier = userDetail?.Role?.Role_Identifier;
  const mainLoader = useSelector((state: any) => state.auth.mainLoader);
  const dispatch = useDispatch();
  const location = useLocation();
  const appdata1 = location.state || '';
  const token = useSelector((state: any) => state.auth.token);

  const [reviewedData1, setreviewedData1] = useState<any>();
  // const [step, setStep] = useState<number>();

  // const handleNext = (): void => {
  //     if (step < 3) setStep(step + 1);
  //     window.scrollTo({ top: 0, behavior: 'smooth' });

  // };

  // const handleBack = (): void => {
  //     if (step > 1) setStep(step - 1);
  //     window.scrollTo({ top: 0, behavior: 'smooth' });

  // };
  const [conditionsData, setConditionsData] = useState<any>([]);

  const formReviewDetails = async () => {
    try {
      dispatch(setMainLoader(true))
      const resp = await getAggreementFormReview(token, appdata1?.Sponsor_Id);
      if (resp?.success) {
       
        setConditionsData(resp?.data?.uploadedText?.Cultivation ? resp?.data?.uploadedText?.Cultivation : sponsorRegistration);

        setreviewedData1(resp?.data)
      } else {
        toast.error(resp?.message, { position: "top-right" });
      }
    } catch (err) {
      toast.error(err, { position: "top-right" });
    } finally {
      dispatch(setMainLoader(false))
    }
  }

  useEffect(() => {
    formReviewDetails();
  }, [appdata1?.Sponsor_Id])

  return (
    <div>

      <ToastContainer />

      <div className="page-wrapper">
        {(roleIdentifier === "MBA" || roleIdentifier === "SPO") && (
          <MBAformN
            setConditionsData={setConditionsData}
            conditionsData={conditionsData}
            reviewedData={reviewedData1}
            appdata={appdata1}
            roleIdentifier={roleIdentifier}
          />)}
        {roleIdentifier === "MBMD" && (
          <MDformO
            reviewedData={reviewedData1}
            appdata={appdata1}
            setConditionsData={setConditionsData}
            conditionsData={conditionsData}
            roleIdentifier={roleIdentifier}
          />)}
        {/* {step === 2 && (
        <SponsorRegistrationP2
          onBack={handleBack}
          onNext={handleNext}
        />)}

       
        {step === 3 && (
          <SponsorRegistrationP3 />
        )} */}

      </div>
    </div>
  )
}

export default MarketingBoardAgreement